import { BID_TABLE_CONTENT_TABLE1 } from '../bid/constant/bid-table-content';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BID_FORM_CONTENT } from '../bid/constant/bid-form-content';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BidSaveData, MakeBidService } from './service/make-bid.service';
import { BidBaseInfo, BidItem, BidItemDetail, BidTotalItem, DataOfTabel1 } from '../bid/interface/make-bid.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-make-bid',
  templateUrl: './make-bid.component.html',
  styleUrls: ['./make-bid.component.scss']
})
export class MakeBidComponent implements OnInit {
  @Input() makeBidStatus: boolean = true;
  @Input() makeBidEditStatus: boolean = true;
  @Input() formid: string;
  @Input() getAssignPhone: string;//厂务工程师电话
  @Output() getSubmitBidSaveData = new EventEmitter<object>();

  isVisible: boolean = false;//是否展开标单编辑页面
  vendorCode: string;//登录的厂商vendorCode

  submitBidSaveData = {};//保存成功的标单信息
  bidSaveData: BidSaveData = {};
  bidBaseInfor: BidBaseInfo = {};
  bidMaterialList: BidTotalItem = {};
  bidItem: BidItem[] = [];
  bidItemDetail: BidItemDetail[] = [];

  // 标单form-content
  formContent = BID_FORM_CONTENT;

  // table1数据
  table1Data = BID_TABLE_CONTENT_TABLE1;
  listOfTable1Data: DataOfTabel1[] = [];

  // table2数据
  table2DataModel = {};
  initBaseMaterialData = [];//初始化的BaseMaterial的数组
  listOfBaseMaterialData = [];//当前条件下的BaseMaterial的数组
  allBaseMaterialData = {};//所有的BaseMaterial的数组

  // DB中base_material_list的数据
  selectColumns = ["bigType", "middleType", "smallType", "projectName", "brandNative", "specType"];
  outputColumns = ["pn", ...this.selectColumns, "unit", "notInUnitPrice"];
  table2Columns = ["pn", ...this.selectColumns, "unit", "quantity", "notInUnitPrice", "notInTotalPrice", "remark"];
  baseMaterialData: BidItemDetail = {};

  constructor(
    private lb4ApiService: Lb4ApiService,
    private makeBidService: MakeBidService,
    private message: NzMessageService,
    private translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    const currentUrl = location.pathname;// 获取当前url
    this.vendorCode = currentUrl.includes('manufacturerbidconfig') ? localStorage.getItem('userid').length > 7 ? localStorage.getItem('userid') : localStorage.getItem('userid').slice(0, -1) : localStorage.getItem('vendorCode');

    await this.getInitDisplayTask();// 获取厂务工程师名字 方案出处 table1的比例
    await this.getOnInitTable2Data();//获取制定标单的table2数据
    await this.getHistorySaveData();//获取历史保存数据
    this.getOnInitTable1Data();//获取制定标单的table1数据
  }

  async getInitDisplayTask() {
    await this.makeBidService.getInitDisplayTask(this.formid, this.vendorCode).then(res => {
      this.bidSaveData = res;
      this.bidBaseInfor = res.bidBaseInfor;
      this.bidMaterialList = res.bidMaterialList;
      this.isVisible = true;
    });
  }
  // 获取初始化的下拉选项
  async selectValueChange(obj: Object) {
    await this.makeBidService.selectValueChange(obj, this.formid, this.vendorCode).then(res => {
      this.bidSaveData = res.bidSaveData;
      this.initBaseMaterialData = res.listOfBaseMaterialData;
      this.listOfBaseMaterialData = res.listOfBaseMaterialData;
      this.bidItem = this.bidSaveData.bidItem;
      this.bidItemDetail = this.bidSaveData.bidItemDetail;
      this.getSubmitBidSaveData.emit({ "submitBidSaveData": this.submitBidSaveData, "bidSaveData": this.bidSaveData });
    });
  }

  // 子组件中form改变后触发
  formChanged(obj: Object, type: string) {
    // obj={ "key": key, "value": value }
    this.bidBaseInfor[obj['key']] = obj['value'];
    this.bidSaveData.bidBaseInfor = this.bidBaseInfor;
  }
  // 子组件中item改变触发
  itemChange(obj: Object) {
    // "event", event, "index", index
    let value = obj['event'];
    let index1 = obj['index1'];
    this.listOfBaseMaterialData[index1]['item'] = value;
  }
  // 子组件中table1备注改变触发
  table1RemarkChanged(e: object) {
    //{ "index": index1, "value": e }
    if (e['index'] === 0) {
      this.listOfTable1Data[e['index']]['remark'] = e['value'];
      this.bidMaterialList.materialCostRemark = e['value'];
    }
    else if (e['index'] === 1) {
      this.listOfTable1Data[e['index']]['remark'] = e['value'];
      this.bidMaterialList.profitRemark = e['value'];
    }
    else if (e['index'] === 2) {
      this.listOfTable1Data[e['index']]['remark'] = e['value'];
      this.bidMaterialList.taxRatesRemark = e['value'];
    }
    else {
      this.listOfTable1Data[e['index']]['remark'] = e['value'];
      this.bidMaterialList.remark = e['value'];
    }
    this.bidSaveData.bidMaterialList = this.bidMaterialList;
  }
  // 子组件中table1的占比change
  table1ScaleChanged(e: object) {
    this.listOfTable1Data[e['index']]['scale'] = e['value'] + '%';
    this.listOfTable1Data[e['index']]['scaleNumber'] = e['value'];
    if (e['index'] === 1) {
      this.bidSaveData.bidMaterialList.profit = this.listOfTable1Data[e['index']]['scale'];
    }
    else {
      this.bidSaveData.bidMaterialList.taxRates = this.listOfTable1Data[e['index']]['scale'];
    }
  }

  // 新增大项
  async addList(index1: number) {
    let listOfBaseMaterialData = [...this.listOfBaseMaterialData];
    listOfBaseMaterialData.splice(index1 + 1, 0, JSON.parse(JSON.stringify(this.table2DataModel)));
    this.listOfBaseMaterialData = listOfBaseMaterialData;
  }

  // 删除大项
  async delList(index1: number) {
    let item = this.listOfBaseMaterialData[index1]['item'];
    let listOfBaseMaterialData = [...this.listOfBaseMaterialData];
    if (this.listOfBaseMaterialData.length > 1) {
      // 删除this.listOfBaseMaterialData中的此大项
      listOfBaseMaterialData.splice(index1, 1);
      this.listOfBaseMaterialData = listOfBaseMaterialData;
      // // 删除table:bid_item和bid_item_detail中的相关数据
      let idOfBidItem = await this.lb4ApiService.find('bid_item', {
        order: 'id DESC',
        fields: { id: true },
        where: { formId: this.formid, vendorCode: this.vendorCode, item: item }
      });
      if (idOfBidItem.length > 0) {
        // 删除bid_item表中的数据
        this.lb4ApiService.deleteById('bid_item', idOfBidItem[0]['id']);
      }
    } else {
      this.message.create('warning', this.translateService.instant('CommonMessageTip.delBidListTip'));
    }
    if (this.listOfBaseMaterialData.length === 0) {
      this.listOfBaseMaterialData = this.initBaseMaterialData;
    }
  }

  // 添加行
  async addRow(obj: Object) {
    // {"index1":index1,"index2":index2}
    const index1 = obj['index1'];
    const index2 = obj['index2'];
    this.listOfBaseMaterialData[index1]['itemDetail'].splice(index2 + 1, 0, JSON.parse(JSON.stringify(this.baseMaterialData)));
  }

  // 删除行
  async delRow(obj: Object) {
    // {"index1":index1,"index2":index2}
    const index1 = obj['index1'];
    const index2 = obj['index2'];
    if (this.listOfBaseMaterialData[index1]['itemDetail'].length > 1) {
      this.listOfBaseMaterialData[index1]['itemDetail'].splice(index2, 1);
    }
    else {
      this.message.create('warning', this.translateService.instant('CommonMessageTip.delBidRowTip'));
    }
  }

  // 保存标单数据
  async saveBid() {
    this.makeBidService.saveBid(this.formid, this.vendorCode, this.listOfBaseMaterialData, this.bidSaveData).then(res => {
      if (JSON.parse(JSON.stringify(res.submitBidSaveData)) !== '{}') {
        this.submitBidSaveData = res.submitBidSaveData;
        this.bidSaveData['bidItem'] = res.bidSaveData.bidItem;
        this.bidSaveData['bidItemDetail'] = res.bidSaveData.bidItemDetail;
        this.getSubmitBidSaveData.emit({ "submitBidSaveData": this.submitBidSaveData, "bidSaveData": this.bidSaveData });
      }
    });
  }
  // 将标单数据下载至本地
  async downloadBid() {
    const step = 5;
    // 标单信息!==已保存的标单信息
    if (JSON.stringify(this.submitBidSaveData) !== JSON.stringify(this.bidSaveData)) {
      this.message.create('error', this.translateService.instant('CommonMessageTip.saveBidTip'));
    }
    else {
      this.makeBidService.downloadBid(this.bidSaveData, this.listOfTable1Data, this.listOfBaseMaterialData, step);
    }
  }

  // 初始化的时候先检查DB有没有已保存的数据,有则显示在标单中
  async getHistorySaveData() {
    await this.makeBidService.getHistorySaveData(this.formid, this.vendorCode, this.getAssignPhone).then(res => {
      this.bidMaterialList = res.bidSaveData.bidMaterialList;
      this.bidBaseInfor = res.bidSaveData.bidBaseInfor;
      this.bidSaveData = res.bidSaveData;
      this.listOfBaseMaterialData = res.listOfBaseMaterialData;
    });
  }

  getOnInitTable1Data() {
    let bidMaterialList = this.bidSaveData.bidMaterialList;
    this.makeBidService.getInitTable1Data(
      Number(bidMaterialList.profit.replace('%', '')), Number(bidMaterialList.taxRates.replace('%', '')),
      bidMaterialList.materialCostRemark, bidMaterialList.profitRemark,
      bidMaterialList.taxRatesRemark,
    ).then(res => {
      this.listOfTable1Data = res.listOfTable1Data;
    });
  }
  async getOnInitTable2Data() {
    await this.makeBidService.getInitTable2Data().then(res => {
      this.table2DataModel = res.table2DataModel;
      this.baseMaterialData = res.baseMaterialData;
      this.allBaseMaterialData = res.allBaseMaterialData;
    });
  }
}
